import { render, staticRenderFns } from "./EmploymentHistoryTab.vue?vue&type=template&id=615a4598&scoped=true"
import script from "./EmploymentHistoryTab.vue?vue&type=script&lang=js"
export * from "./EmploymentHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./EmploymentHistoryTab.vue?vue&type=style&index=0&id=615a4598&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a4598",
  null
  
)

export default component.exports